module.exports = __webpack_public_path__ + "static/media/Gill_S1_22_Liestyle_Paddy_Hoodie_4.fe658986.jpg";